// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-c2e682cc] .formulate-input-element--password .toggle{top:.5rem}", ""]);
// Exports
module.exports = exports;
